module.exports = __webpack_public_path__ + "public/images/header/otm.bc9c748ffc0d2a5282091dd6da853f38.svg";